<!-- Topbar Start -->
<div class="navbar-custom">
    <div class="container-fluid">
        <ul class="list-unstyled topnav-menu float-end mb-0">

            <!-- brands menu -->
<!--            <li class="d-none d-lg-inline-block topbar-dropdown" ngbDropdown>-->
<!--                <a class="nav-link arrow-none waves-effect waves-light" href="javascript:void(0)" ngbDropdownToggle-->
<!--                    role="button">-->
<!--                    <i class="fe-grid noti-icon"></i>-->
<!--                </a>-->
<!--                <div class="dropdown-lg dropdown-menu-end" ngbDropdownMenu>-->
<!--                    <div class="p-lg-1">-->
<!--                        <div class="row g-0 row-cols-3">-->
<!--                            <div class="col" *ngFor="let brand of brands">-->
<!--                                <a class="dropdown-icon-item" href="javascript:void(0)">-->
<!--                                    <img [src]="brand.logo" [alt]="brand.name">-->
<!--                                    <span>{{brand.name}}</span>-->
<!--                                </a>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                    </div>-->

<!--                </div>-->
<!--            </li>-->

            <li class="notification-list topbar-dropdown" ngbDropdown>
               <app-restaurant-selection></app-restaurant-selection>
            </li>

            <!-- profile menu -->
            <li class="dropdown notification-list  topbar-dropdown" ngbDropdown>
                <a ngbDropdownToggle class="nav-link nav-user  me-0 waves-effect waves-light" id="profileMenuDropdown"
                    href="javascript:void(0)" aria-expanded="false">
<!--                    <span class="account-user-avatar">-->
<!--                        <img [src]="loggedInUser?.avatar" alt="user-image" class="rounded-circle">-->
<!--                    </span>-->
                    <span class="pro-user-name ms-1">
                        {{loggedInUser.name}} <i class="mdi mdi-chevron-down"></i>
                    </span>

                </a>
                <div ngbDropdownMenu aria-labelledby="profileMenuDropdown" class="dropdown-menu-end profile-dropdown">
                    <!-- item -->
<!--                    <a class="notify-item" ngbDropdownItem>-->
<!--                        <i class="fe-user me-1"></i>-->
<!--                        <span style="cursor: pointer;" >Moje konto</span>-->
<!--                    </a>-->
<!--                    <a class="notify-item" ngbDropdownItem>-->
<!--                        <i class="fe-settings me-1"></i>-->
<!--                        <span style="cursor: pointer;" >Ustawienia</span>-->
<!--                    </a>-->
                    <a class="notify-item" ngbDropdownItem (click)="changePassword()">
                        <i class="fe-lock me-1"></i>
                        <span style="cursor: pointer;" >Zmień hasło</span>
                    </a>
                    <a class="notify-item" ngbDropdownItem (click)="logout()">
                        <i class="fe-log-out me-1"></i>
                        <span style="cursor: pointer;" >Wyloguj się</span>
                    </a>
                </div>
            </li>


        </ul>

        <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
            <li>
                <button class="button-menu-mobile waves-effect waves-light d-none d-lg-block"
                    (click)="changeSidebarWidth()" *ngIf="layoutType!=='horizontal'">
                    <i class="fe-menu"></i>
                </button>
            </li>

            <li>
                <button class="button-menu-mobile open-left d-block d-lg-none waves-effect waves-light"
                    *ngIf="layoutType!=='horizontal'" (click)="toggleMobileMenu($event)">
                    <i class="fe-menu"></i>
                </button>
            </li>

            <li>
                <!-- Mobile menu toggle (Horizontal Layout)-->
                <a class="navbar-toggle nav-link" [ngClass]="{'open': topnavCollapsed}"
                    (click)="toggleMobileMenu($event)" *ngIf="layoutType==='horizontal'">
                    <div class="lines">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </a>
                <!-- End mobile menu toggle-->
            </li>
        </ul>
        <div class="clearfix"></div>
    </div>
</div>
<!-- end Topbar -->
